import Box from '@material-ui/core/Box';
import { hasValue, loadStyle } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useMemo } from 'react';
import { object } from 'yup';
import RenderComponent from './RenderComponent';
import { commonSchema, editSchema } from './schema';
import ParentStyled from './style';

const Styled = loadStyle(ParentStyled, 'modules/UserProfile');
const layout = window?.$environment?.CURRENT_LAYOUT;
const CustomMessage = lazy(() => import(`globalcomponents/CustomMessage/${layout}`));
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Component {...contentProps} />
    </Box>
  );
};
export default Index;

const Component = ({
  apiStatus,
  token,
  clearApiStatus,
  fetchApiId,
  updateApiId,
  updateProfile,
  callback,
  isEditable,
  i18n,
  profile,
  getCsvStatusHistory,
  generateMfaQrCode,
  validateMfaSetup,
  modifyMfaSettings,
}) => {
  const validationScheme = useMemo(() => {
    if (isEditable) return editSchema;
    return commonSchema;
  }, [isEditable]);

  const hasFetchApiStatus = hasValue(apiStatus.status, 'api', fetchApiId);
  const hasUpdateApiStatus = hasValue(apiStatus.status, 'api', updateApiId);
  return (
    <Styled.Wrapper>
      <CustomMessage type="error" message={i18n.t(hasFetchApiStatus?.errorMessage || hasUpdateApiStatus?.errorMessage)} />
      <Form
        type="server"
        direction="row"
        initialValues={{ ...profile }}
        RenderComponent={RenderComponent}
        handleOnSubmit={(fields) => {
          if (token) {
            updateProfile({
              data: {
                newPassword: fields.password,
                confirmPassword: fields.confirmPassword,
                token,
              },
              apiId: updateApiId,
              callback: callback,
            });
          } else {
            delete fields['confirmPassword'];
            updateProfile({
              data: fields,
              callback: callback,
              apiId: updateApiId,
            });
          }
        }}
        customProps={{
          hasApiStatus: hasUpdateApiStatus,
          disabled: !isEditable,
          clearApiStatus: clearApiStatus,
          mfaStatus: profile.mfaStatus,
          qrString: profile.qrString,
          Styled,
          i18n,
          getCsvStatusHistory,
          generateMfaQrCode,
          validateMfaSetup,
          modifyMfaSettings,
        }}
        validationSchema={object().shape({
          ...validationScheme,
        })}
      />
    </Styled.Wrapper>
  );
};

// export default Component;

Component.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  updateProfile: PropTypes.func.isRequired,
  profile: PropTypes.object,
  i18n: PropTypes.array.isRequired,
  callback: PropTypes.func.isRequired,
  token: PropTypes.string,
};
